import './button-check-done.scss'
// utils
import sendGaPush from '../../../utils/sendGaPush'
// components
import Image from '../../atoms/Image/image'
// assets
import iconCheckImg from '../../../assets/images/para-hoy/Status_Off.svg'
import iconCheckDoneImg from '../../../assets/images/para-hoy/Status_On.svg'

const ButtonCheckDone = props => {
	const {
		category = 'SaludContinuarediseno',
		action = 'ClicParaHoy',
		handleActivate,
		data,
		alt,
		active = false,
		classes = ''
	} = props

	// metrics
	const handleSendGaPush = ({ label }) => {
		sendGaPush({ category, action, label })
	}

	return (
		<button
			className={`button-check-done ${classes}`}
			onClick={() => {
				handleSendGaPush({ label: 'Recordatorio ya lo hice' })
				return handleActivate && handleActivate(data)
			}}
		>
			<Image src={active ? iconCheckDoneImg : iconCheckImg} alt={alt} width='50' height='50' />
		</button>
	)
}

export default ButtonCheckDone
